import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import classes from './ContactInfo.module.scss'
import classNames from 'classnames'

const ContactInfo = ({ fullName, familyAdminsNames, familyAdminsEmails, email, phone }) => {
  const { t } = useTranslation()

  return (
    <div className={classes.container}>
      <h5 className={classes.heading}>{t('programs.manage.contactInfo.heading')}</h5>
      <div className={classes.row}>
        <p className={classes.label}>{t('programs.common.fields.golfer')}</p>
        <p className={classes.value}>{fullName || '-'}</p>
      </div>
      <div className={classes.row}>
        <p className={classes.label}>
          {t('programs.manage.contactInfo.familyAdmins', { count: familyAdminsNames.length })}
        </p>
        <ul className={classes.multipleValueList}>
          {familyAdminsNames.map((fullName, idx) => (
            <li key={idx}>
              <p className={classNames(classes.value, 'mb-1')}>{fullName}</p>
            </li>
          ))}
        </ul>
      </div>
      <div className={classes.row}>
        <p className={classes.label}>
          {email ? t('common.field.email') : t('programs.manage.contactInfo.familyAdminsEmails')}
        </p>
        {email ? (
          <p className={classes.value}>{email}</p>
        ) : (
          <ul className={classes.multipleValueList}>
            {familyAdminsEmails.map((email, idx) => (
              <li key={idx}>
                <p className={classNames(classes.value, 'mb-1')}>{email}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className={classes.row}>
        <p className={classes.label}>{t('common.field.phoneNumber')}</p>
        <p className={classes.value}>{phone || '-'}</p>
      </div>
    </div>
  )
}

ContactInfo.propTypes = {
  fullName: PropTypes.string,
  familyAdminsNames: PropTypes.arrayOf(PropTypes.string),
  familyAdminsEmails: PropTypes.arrayOf(PropTypes.string),
  email: PropTypes.string,
  phone: PropTypes.string,
}

export default ContactInfo
